import { BaseEntity } from "./BaseEntity";
import { Company } from "./Company";
import { Service } from "./Service";
import { Training } from "./Training";
import { Typology } from "./Typology";
import { User } from "./User";

export class Internship extends BaseEntity {
    public name: string = "";
    public description?: string = "";
    public capacity: number = 0;
    public service: string | Service = "";
    public training: string | Training = "";
    public typology: string | Typology = "";
    public company?: string | Company = "";
    public internshipTutors?: string[] | User[] = [];

    constructor(model: Partial<Internship> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PInternship = Partial<Internship>;
